var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderDrug = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 3.33333H8.33337",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 8.3335V10.3335",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83792 13.0808L6.71658 10.9594C6.32592 10.5688 6.32592 9.93544 6.71658 9.54544V9.54544C7.10725 9.15477 7.74058 9.15477 8.13058 9.54544",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7239 9.30928L9.07394 7.65994C8.68328 7.26928 8.04994 7.26928 7.65994 7.65994V7.65994C7.26928 8.05061 7.26928 8.68394 7.65994 9.07394L9.30994 10.7239",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5452 8.13156C9.15453 7.74089 9.15453 7.10756 9.5452 6.71756V6.71756C9.93586 6.32689 10.5692 6.32689 10.9592 6.71756L12.6092 8.36756",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9026 7.66012C11.512 7.26946 11.512 6.63613 11.9026 6.24613V6.24613C12.2933 5.85546 12.9266 5.85546 13.3166 6.24613L14.4953 7.42479L14.024 6.95346L15.2026 8.13213C17.1553 10.0848 17.1553 13.2508 15.2026 15.2035V15.2035C13.25 17.1561 10.084 17.1561 8.1313 15.2035L7.28597 14.3581C7.07264 14.1448 6.95264 13.8555 6.95264 13.5535V13.5535C6.95264 13.2515 7.07264 12.9621 7.28597 12.7488L7.8953 12.1395",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 3.3335H4.66659C3.92992 3.3335 3.33325 3.93016 3.33325 4.66683V5.3335",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 13.3333V13.9999C3.33325 14.7366 3.92992 15.3333 4.66659 15.3333H5.33325",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 5.3335V4.66683C15.3333 3.93016 14.7366 3.3335 13.9999 3.3335H13.3333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderDrug);
export default ForwardRef;